var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80.37 80.37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#5940e6",
    height: 80.37,
    rx: 12,
    width: 80.37
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.43 59.93c-.55 0-.72-.35-.38-.79l14.25-18.17c.34-.43.34-1.14 0-1.57l-14.25-18.17c-.34-.43-.17-.79.38-.79h31.52c.55 0 .72.35.38.79l-14.25 18.17c-.34.43-.34 1.14 0 1.57l14.25 18.17c.34.43.17.79-.38.79zm15.12-22.23c.34.43.89.43 1.23 0l11.3-14.37c.34-.43.17-.79-.38-.79h-23.02c-.55 0-.72.35-.38.79l11.25 14.36zm12.15 20.13c.55 0 .72-.35.38-.79l-11.3-14.37c-.34-.43-.9-.43-1.23 0l-11.25 14.36c-.34.43-.17.79.38.79h23.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.95 60.93h-31.52c-.66 0-1.17-.29-1.42-.79s-.16-1.09.25-1.61l14.25-18.18c.05-.07.05-.27 0-.33l-14.25-18.17c-.4-.51-.5-1.11-.26-1.61s.77-.8 1.42-.8h31.52c.66 0 1.17.29 1.42.79s.16 1.09-.25 1.61l-14.25 18.18c-.05.07-.05.27 0 .33l14.25 18.17c.4.51.5 1.11.26 1.61s-.77.8-1.42.8zm-30.46-2h29.41l-13.6-17.34c-.62-.79-.62-2.02 0-2.81l13.6-17.34h-29.41s13.6 17.34 13.6 17.34c.62.79.62 2.02 0 2.81zm26.21-.1h-23.02c-.65-.01-1.18-.31-1.42-.81s-.15-1.1.26-1.61l11.25-14.36c.34-.44.85-.7 1.39-.71.58 0 1.06.25 1.42.7l11.3 14.37c.41.53.5 1.12.25 1.62s-.76.79-1.42.79zm-21.96-2.01h20.9s-10.47-13.31-10.47-13.31zm10.61-13.54s0 0 0 0zm-.18-4.26c-.54 0-1.05-.26-1.4-.7l-.22-.29-11.04-14.09c-.41-.53-.5-1.12-.25-1.62s.76-.79 1.42-.79h23.02c.65 0 1.18.3 1.42.8s.15 1.1-.26 1.61l-11.3 14.37c-.35.45-.86.7-1.4.7zm-10.43-15.48 10.43 13.32 10.47-13.32h-20.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.be65031cd9a5b5fa1df7dbe36acb2d82.svg";
export { ForwardRef as ReactComponent };